__turbopack_context__.v({
  "container": "Default-module__39GcBq__container",
  "disabled": "Default-module__39GcBq__disabled",
  "does-not-exist": "Default-module__39GcBq__does-not-exist",
  "hasDesc": "Default-module__39GcBq__hasDesc",
  "highlighted": "Default-module__39GcBq__highlighted",
  "isOpen": "Default-module__39GcBq__isOpen",
  "js-has-pseudo": "Default-module__39GcBq__js-has-pseudo",
  "menuBottomPosition": "Default-module__39GcBq__menuBottomPosition",
  "menuTopPosition": "Default-module__39GcBq__menuTopPosition",
  "option": "Default-module__39GcBq__option",
  "options": "Default-module__39GcBq__options",
  "placeholderOption": "Default-module__39GcBq__placeholderOption",
  "selected": "Default-module__39GcBq__selected",
  "value": "Default-module__39GcBq__value",
});
